import * as React from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Backdrop, Box, Paper } from "@mui/material";
import { LoadingProvider } from "./util/LoadingContext";
import LayoutHeader from "./components/page/portal/LayoutHeader";
import LayoutFooter from "./components/page/portal/LayoutFooter";
import AssistentePage from "./components/page/portal/AssistentePage";
import HtmlContent from "./components/util/HtmlContent";

export default function MainAppBar(props) {
  const {pageRoot, darkMode, handleDarkMode, edit, setEdit} = props;
  const location = useLocation();
  const navigate = useNavigate();
  window.globalThis.globalNavigate = navigate;

  const isChat = location.pathname.startsWith('/chat');
  
  const update = (e) => {
    console.log(">>>update<<<<", e );    
  }

  if( pageRoot && pageRoot.layout && pageRoot.layout.tipo === 'portal'){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const apiUrl = urlParams.get('fullsize') === "true";
    let style = null;
    if( pageRoot.estilo){
      style = {}
      const arr = pageRoot.estilo.split(";")      
      for( let x of arr){
        if( x.length > 1){
          let sp = x.split(":")
          let key = sp[0];
          const val = sp[1];
          sp = key.split('-');
          if( sp.length > 1){
            key = sp[0]+sp[1].charAt(0).toUpperCase() + sp[1].slice(1);
          }
          style[key] = val;
          style.minHeight= '100vh';
        }
      }
    }
    
    return (
      <div 
        style={style?style:{ 
          // minHeight:'100vh'
          // background: '#141c30'
        }}
      > 
        {apiUrl && <Outlet />}
        {!apiUrl &&<>
        <LoadingProvider>
          <LayoutHeader darkMode={darkMode} handleDarkMode={handleDarkMode} edit={edit} pageRoot={pageRoot} ></LayoutHeader>
          
          <Outlet context={{ update }} />
        </LoadingProvider>
        {!isChat && <LayoutFooter edit={edit} setEdit={setEdit} />}
        </>}
      </div>
    )
  }

  if( pageRoot && pageRoot.layout && pageRoot.layout.tipo !== 'portal'){    
    return (
      <Paper style={{ minHeight:'100vh'}}>
        <p>não implementado</p>
      </Paper>
    )
  }
  if( pageRoot && pageRoot.pagina){
    return (
    <div 
    style={{ minHeight:'100vh'}}
    >
        <HtmlContent htmlString={pageRoot? pageRoot.pagina:''} edit={edit}/> 
        <Outlet context={{ update }} /> 
      </div>
    );
  }

  return (
    <React.Fragment>
      <AssistentePage/>      
    </React.Fragment>
  )
}
